import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import _ from "lodash";
import { InputText } from 'primereact/inputtext';
import { DataView } from 'primereact/dataview';

import "./index.css"

import Loading from "../../../common/Loading";

import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { fetchMaterialBrands, fetchStates, fetchMaterialCategories, fetchCompanySupplyType } from "../../../services/redux/reducers/commonThunk";
import { fetchBuyerPOs, updateSearchParams } from '../../../services/redux/reducers/buyerPO/buyerPO';
import { getBuyerInvoicesByBuyerPOIds } from '../../../services/api/buyerInvoice';
import { getStockDocsByDocNos } from '../../../services/api/stockDoc';
import { getPOPunchOrderDetailsByBuyerPOIds } from '../../../services/api/poPunch';

import OrderItemTemplate from './Components/OrderItemTemplate';

import PurchaseOrderMobileSkeleton from '../../../skeletons/PurchaseOrderMobile';
import PurchaseOrderDesktopSkeleton from '../../../skeletons/PurchaseOrderDesktop';

import { isMobile } from '../../../utils';
import { stockDocParser } from '../../../parserFunctions'


const BuyerPurchaseOrder = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [isSearchVisible, setIsSearchVisible] = useState(true)

    const [sellerPOItems, setSellerPOItems] = useState([])
    const [stocDocs, setStocDocs] = useState([])
    const [dispatchNotes, setDispatchNotes] = useState([])
    const [invoiceDispatchMap, setInvoiceDispatchMap] = useState([])
    const [buyerInvoices, setBuyerInvoices] = useState([])
    const [buyerInvoiceItems, setBuyerInvoiceItems] = useState([])
    const [materialDetails, setMaterialDetails] = useState([])
    const [dispatchNoteItems, setDispatchNoteItems] = useState([])
    const [poPunchDetails, setPOPunchDetails] = useState([])

    const userDetails = useSelector(state => state.userDetails)
    const isPageLoading = useSelector(state => state.buyerPOData.loading)
    const searchParams = useSelector(state => state.buyerPOData.searchParams)
    const paginationParams = useSelector(state => state.buyerPOData.paginationParams)
    const buyerPOData = useSelector(state => state.buyerPOData.buyerPOData)
    
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchStates())
        dispatch(fetchMaterialBrands())
        dispatch(fetchMaterialCategories())
        dispatch(fetchCompanySupplyType())

        let branchIds = []
        let companyIds = []
        if(userDetails?.activeUserRoleDetails?.branchId){
            branchIds.push(userDetails?.activeUserRoleDetails?.branchId)
        } else {
            companyIds.push(userDetails?.activeUserRoleDetails?.companyId)
        }
        dispatch(updateSearchParams({...searchParams, branchIds, companyIds, isRecurringPO: true}))

        dispatch(fetchBuyerPOs({...paginationParams, branchIds, companyIds, isRecurringPO: true, ...searchParams, pageNo: 0}))
    }, [])

    useEffect(() => {
        getBuyerInvoices()
        getStockDocs()
        getOrderedQuantities()
    }, [buyerPOData])

    const getBuyerInvoices = async () => {
        let buyerPOIds = buyerPOData?.map(eachBuyerPO => eachBuyerPO?.buyerPOId)
        if (buyerPOIds?.length > 0){
            let data = { buyerPOIds: buyerPOIds }
            const response = await getBuyerInvoicesByBuyerPOIds(data)
            if (response.failure) {
                dispatch(raiseToast({ severity: 'error', summary: 'Buyer Invoice', detail: response.data.error, life: 3000 }))
            } else {
                setSellerPOItems(response?.data?.sellerPOItems)
                setDispatchNotes(response?.data?.dispatchNotes)
                setDispatchNoteItems(response?.data?.dispatchNoteItems)
                setInvoiceDispatchMap(response?.data?.invoiceDispatchMap)
                setBuyerInvoices(response?.data?.buyerInvoice)
                setBuyerInvoiceItems(response?.data?.buyerInvoiceItems)
                setMaterialDetails(response?.data?.materialDetails)
            }
        }
    }

    const getStockDocs = async() => {
        let docNos = buyerPOData?.map(eachBuyerPO => eachBuyerPO?.docNo)
        if (docNos?.length > 0){
            const stocDocRes = await getStockDocsByDocNos({docNos : docNos})
            // console.log("stocDocNos", stocDocRes)
            setStocDocs(stockDocParser(stocDocRes?.data))
        }
    }

    const getOrderedQuantities = async() => {
        let buyerPOIds = buyerPOData?.map(eachBuyerPO => eachBuyerPO?.buyerPOId)
        if (buyerPOIds?.length > 0){
            const poOrderDetails = await getPOPunchOrderDetailsByBuyerPOIds({buyerPOIds: buyerPOIds})
            console.log("poOrderDetails", poOrderDetails, buyerPOIds)
            setPOPunchDetails(poOrderDetails?.data)
        }
    }

    const handlePageChange = async (e) => {
        let buyerPOParams = {
            paginator: true,
            pageNo: e.page + 1,
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            ...searchParams
        }
        if (buyerPOParams.searchBy !== "all") {
            buyerPOParams[buyerPOParams.searchBy] = buyerPOParams.searchText.trim()
        }
        dispatch(fetchBuyerPOs({ ...buyerPOParams }))
    }

    const handleSearchTextChange = (event) => {
        let eventValue = event.target.value
        const updatedSearchParams = {...searchParams, [event.target.name]: eventValue}
        dispatch(updateSearchParams(updatedSearchParams))
    }

    const orderTemplate = (row) => {
        return (
            <OrderItemTemplate 
                orderItem={row} 
                materialDetails={materialDetails} 
                stocDocs={stocDocs} 
                poPunchDetails={poPunchDetails} 
                dispatchNoteItems={dispatchNoteItems} 
                dispatchNotes={dispatchNotes}
                invoiceDispatchMap={invoiceDispatchMap}
                buyerInvoices={buyerInvoices}
                buyerInvoiceItems={buyerInvoiceItems}
            />
        )
    }

    const handleSearch = () => {
        const updatedSearchParams = {...searchParams}
        if(searchParams.searchText === ""){
            updatedSearchParams.searchBy = "all"
        } else {
            updatedSearchParams.searchBy = "docNo"
        }
        dispatch(fetchBuyerPOs({...paginationParams, ...searchParams, pageNo: 0}))
    }

    if(isLoading){
        return(
            isMobile() ? <PurchaseOrderMobileSkeleton /> : <PurchaseOrderDesktopSkeleton />
        )
    }
    
    return (
        <div className="openpo-layout flex flex-column">
            <div className="flex flex-column md:flex-row justify-content-between invoices-header-section" >
                <h3 className="m-2" style={{borderBottom: "2px solid #0da487"}}>Purchase Orders</h3>

                <div className="catalogue-request-search md:w-5 p-input-icon-right">
                    <div className="flex flex-row justify-content-center align-items-center" 
                        style={{position: "absolute", width: "50px", height: "45px", right: 0, backgroundColor: "#ffa53b", borderTopRightRadius: "6px", borderBottomRightRadius: "6px", cursor: "pointer"}}
                        onClick={handleSearch}
                    >
                        <i className="pi pi-search" style={{color: "white", fontSize: "17px", marginTop: "3px"}} />
                    </div>
                    <InputText placeholder="Enter document number" value={searchParams["searchText"]} style={{ width: "100%", height: "45px", fontSize: "16px", borderColor: "#ececec" }} name="searchText" onChange={(e) => handleSearchTextChange(e)} />
                </div>

                <div className="flex w-1">
                </div>
            </div>

            <div className='flex flex-row invoices-table-container' >
                <div className="open-po-table" style={{ order: "1", width: isSearchVisible ? "100%" : "100%" }}>
                    <div className=''>
                            <DataView 
                                value={buyerPOData} 
                                totalRecords={paginationParams?.totalRecords}
                                itemTemplate={orderTemplate} 
                                paginator 
                                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                                currentPageReportTemplate=""  // {first} to {last} of {totalRecords}
                                rows={paginationParams?.recordsPerPage}
                                loading={isPageLoading}
                                onPage={e => handlePageChange(e)}
                                page={paginationParams.pageNo}
                                first={paginationParams.pageNo * paginationParams.recordsPerPage}
                                lazy
                            />
                    </div>
                </div>
            </div>
            <Loading visible={isLoading} />
        </div>
    )
}

export default BuyerPurchaseOrder